import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "panel-frame flex justify-content-center" }
const _hoisted_2 = { class: "md:mr-s3 lg:mr-s6" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "caption" }, "Your total vest", -1)
const _hoisted_4 = { class: "text-bold flex align-items-center" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" BLUES ")
const _hoisted_7 = { class: "md:ml-s3 lg:ml-s6" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "caption" }, "You already claimed", -1)
const _hoisted_9 = { class: "text-bold flex align-items-center" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" BLUES ")

import { useVesting } from '@/composables/core/useVesting';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { totalVestFormatted, alreadyClaimedFormatted } = useVesting();

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (!_unref(totalVestFormatted))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              class: "mr-2 w-4rem"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(totalVestFormatted)) + " ", 1)),
        _hoisted_6
      ])
    ]),
    _createVNode(_component_Divider, {
      layout: "vertical",
      class: "mx-s8"
    }),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        (!_unref(totalVestFormatted))
          ? (_openBlock(), _createBlock(_component_Skeleton, {
              key: 0,
              class: "mr-2 w-4rem"
            }))
          : (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(_unref(alreadyClaimedFormatted)) + " ", 1)),
        _hoisted_11
      ])
    ])
  ]))
}
}

})